<template>
  <Header/>
  <router-view/>
</template>

<script>
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Header
  }
}
</script>

<style>
* {
  margin: 0px;
  padding: 0px;
  list-style: none;
	text-decoration: none;
	border: none;
	outline: none;
}

html {
  width: 100%!important;
}

#app {
  font-family: 'Helvetica Neue',Arial,Helvetica,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>

